import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Modal,
  Typography,
  Divider,
  message,
  notification,
  Spin,
  Space,
} from "antd";
import { gaEvent } from "analytics/analytics";

import VariantsTable from "./VariantsTable";
import API_KEY from "api";
import { getProductDetailsV2 } from "api/customApis";
import {
  ImageContainer,
  DeleteButton,
  EditButton,
  PriceTitle,
  InfoContainer,
  tansformModalData,
  FileList,
} from "./ModalHelpers";
import * as GA from "constants/analytics";
import { useGlobal } from "store/index";
import JSZipUtils from "jszip-utils";
import JSZip from "jszip";
import { saveAs } from "save-as";
import { MdCloudDownload } from "react-icons/md";
import { LoadingOutlined } from "@ant-design/icons";
import Can from "../../casl/Can";
import { PERMISSIONS } from "constants/permissions";
const antIcon = <LoadingOutlined spin />;
const { Text, Title } = Typography;

export default function ProductDetailsModal({ showModal, setShowModal, id }) {
  const [imgLoaded, setImgLoaded] = useState(false);
  const [deletePopConfirm, setDeletePopConfirm] = useState(false);
  const [loading, setLoading] = useState(true);
  const [modalData, setModalData] = useState({});
  const [globalState, setGlobalState] = useGlobal();
  const [downloading, setDownloading] = useState(false);
  const fields =
    "*, colours.colours_id.name,colours.colours_id.hexcode, product_images.directus_files_id,secondary_category.id,secondary_category.name";

  const refresh = () => {};

  const deleteProduct = (deleteId) => {
    setLoading(true);
    API_KEY.URL.delete(`${API_KEY.path.products}/${deleteId}`)
      .then((res) => {
        setTimeout(function () {
          message.success("Product deleted!");
          setLoading(false);
          sessionStorage.clear();
          setShowModal(false);
          refresh();
          window.location.reload();
        }, 3000);
        setDeletePopConfirm((state) => !state);
      })
      .catch((error) => {
        setLoading(false);
        openNotificationWithIcon();
        setDeletePopConfirm((state) => !state);
      });
  };

  const handleClose = () => {
    if (showModal)
      gaEvent(
        GA.EVENT.CLICK,
        GA.CATEGORY.MASTER_CATALOGUE,
        GA.DESCRIPTION.CATEGORY_WISE_PRODUCT_MODAL_CLOSED,
        modalData?.product_id
      );
    setShowModal(false);
    setModalData({});
    setImgLoaded(false);
  };

  const openNotificationWithIcon = (type = "error") => {
    notification[type]({
      message: "This product is part of catalogues!",
      description:
        "Unable to delete this product at the moment as it is part of catalogues sent to buyers.",
    });
  };

  useEffect(() => {
    if (showModal)
      gaEvent(
        GA.EVENT.CLICK,
        GA.CATEGORY.MASTER_CATALOGUE,
        GA.DESCRIPTION.CATEGORY_WISE_PRODUCT_MODAL_OPENED,
        modalData?.product_id
      );
  }, [showModal]);

  useEffect(() => {
    if (showModal) {
      getProductDetailsV2(id)
        .then((res) => {
          const data = tansformModalData(res.data);
          setModalData(data);
          setLoading(false);
        })
        .catch((e) => {
          message.error("Failed to fetch Product data");
          setLoading(false);
        });
    }
  }, [showModal, id]);

  // handle download function here
  const handleDownload = () => {
    setDownloading(true);
    const imgArray = modalData?.product_images.map((img) => {
      return {
        url: `${process.env.REACT_APP_DIRECTUS}assets/${img.directus_files_id.id}`,
      };
    });

    var zip = new JSZip();
    var count = 0;
    var zipFilename = `${
      modalData?.product_id || modalData?.secondary_category?.name
    }.zip`;

    imgArray.forEach(function (url) {
      // loading a file and add it in a zip file
      JSZipUtils.getBinaryContent(url?.url, function (err, data) {
        if (err) {
          throw err; // or handle the error
        }

        count++;
        const filename = `${
          modalData?.product_id || modalData?.secondary_category?.name
        }-${count}`;
        zip.file(filename + ".jpg", data, { binary: true });
        if (count === imgArray.length) {
          zip.generateAsync({ type: "blob" }).then(function (content) {
            setDownloading(false);
            saveAs(content, zipFilename);
          });
        }
      });
    });
  };

  const renderBody = () => {
    if (loading) return null;
    return (
      <Row>
        <Col span={17}>
          <ImageContainer
            images={modalData?.product_images}
            setImgLoaded={setImgLoaded}
            imgLoaded={imgLoaded}
          />
        </Col>

        <Col span={7}>
          <Row justify="space-between">
            <Col>
              <Text
                className="product-id"
                style={{
                  fontFamily: "Avenir-Roman",
                  marginBottom: "0.5rem",
                  fontSize: 18,
                }}
              >
                {modalData?.product_id ? "ID: " + modalData?.product_id : ""}
              </Text>
            </Col>
          </Row>

          {modalData?.product_id && (
            <Divider
              style={{
                marginTop: 8,
                marginBottom: 8,
                border: "1px solid #E6E7E7",
              }}
            />
          )}

          {/* //casl starts here  */}
          <Can
            I={PERMISSIONS.global_permissions.slug}
            a={PERMISSIONS.global_permissions.permissionType}
          >
            {(allowed) => <PriceTitle data={modalData.priceTitle} />}
          </Can>
          {/* //casl ends here  */}

          {modalData?.sub_category && (
            <Row>
              <Col span={8}>
                <Title style={{ fontSize: "16px", margin: 0 }} type="secondary">
                  {`Sub Category`}
                </Title>
              </Col>

              <Col span={15} offset={1}>
                <span
                  style={{
                    fontSize: "16px",
                    paddingTop: "4px",
                    //  overflowWrap: "break-word",
                    overflowWrap: "break-word",
                  }}
                >
                  {modalData?.sub_category.split(',').join(', ')}
                </span>
              </Col>
            </Row>
          )}
          <InfoContainer data={modalData.productionDetails} />

          {/* //casl starts here  */}
          <Can
            I={
              PERMISSIONS.delete_products.slug ||
              PERMISSIONS.update_products.slug
            }
            a={
              PERMISSIONS.delete_products.permissionType ||
              PERMISSIONS.update_products.permissionType
            }
            passThrough
          >
            {(allowed) =>
              allowed ? (
                <Divider
                  style={{
                    marginBottom: 8,
                    marginTop: 8,
                    border: "0px solid #E6E7E7",
                  }}
                />
              ) : null
            }
          </Can>
          {/* //casl ends here  */}

          <Row justify="space-between" style={{ padding: "1em 0" }}>
            {/* //casl starts here  */}
            <Can
              I={PERMISSIONS.delete_products.slug}
              a={PERMISSIONS.delete_products.permissionType}
            >
              {(allowed) => (
                <Col span={10}>
                  <DeleteButton
                    id={modalData?.id}
                    productId={modalData?.product_id}
                    loading={loading}
                    handleDelete={deleteProduct}
                    setDeletePopConfirm={setDeletePopConfirm}
                    deletePopConfirm={deletePopConfirm}
                  />
                </Col>
              )}
            </Can>
            {/* //casl ends here  */}

            {/* //casl starts here  */}
            <Can
              I={PERMISSIONS.update_products.slug}
              a={PERMISSIONS.update_products.permissionType}
            >
              {(allowed) => (
                <Col span={12}>
                  <EditButton
                    id={modalData?.id}
                    productId={modalData?.product_id}
                  />
                </Col>
              )}
            </Can>
            {/* //casl ends here  */}
          </Row>
          <Divider
            style={{
              marginTop: 8,
              marginBottom: 8,
              border: "0px solid #E6E7E7",
            }}
          />
          {!!modalData?.variants?.length &&
            modalData?.variants?.[0]?.attributes?.length > 0 && (
              <VariantsTable data={modalData.variants} />
            )}
          {!!modalData?.variants?.length &&
            modalData?.variants?.[0]?.attributes?.length > 0 && (
              <Divider
                style={{
                  marginTop: 8,
                  marginBottom: 8,
                  border: "0px solid #E6E7E7",
                }}
              />
            )}

          <InfoContainer data={modalData.others} />

          {/* //casl starts here  */}
          <Can
            I={PERMISSIONS.download_product_images.slug}
            a={PERMISSIONS.download_product_images.permissionType}
          >
            {(allowed) => (
              <>
                <Divider
                  style={{
                    margin: "0 0",
                    marginBottom: 10,
                    border: "0px solid #E6E7E7",
                  }}
                />
                <FileList data={modalData?.others} />
              </>
            )}
          </Can>
          {/* //casl ends here  */}

          <Can
            I={PERMISSIONS.download_product_images.slug}
            a={PERMISSIONS.download_product_images.permissionType}
          >
            <Divider
              style={{
                margin: "0 0",
                marginBottom: 10,
                border: "0px solid #E6E7E7",
              }}
            />
            <Row style={{ marginTop: "1em" }} align="middle">
              <Col>
                <Title style={{ fontSize: 14, margin: 0 }}>
                  {modalData?.product_images.length === 1
                    ? ` ${modalData?.product_images.length} photo uploaded for this product.`
                    : ` ${modalData?.product_images.length} photos uploaded for this product.`}
                </Title>
              </Col>

              <Col>
                <Row
                  style={{
                    color: "#278977",
                    cursor: "pointer",
                    paddingLeft: "1em",
                  }}
                >
                  {downloading ? (
                    <Text
                      style={{
                        fontFamily: "Avenir-Roman",
                        fontSize: 12,
                        color: "inherit",
                      }}
                    >
                      {" "}
                      <Spin
                        spinning={downloading}
                        indicator={antIcon}
                        style={{ fontSize: 16, paddingRight: 2 }}
                      ></Spin>
                      Downloading ...
                    </Text>
                  ) : (
                    <Space onClick={() => handleDownload()}>
                      <Text
                        style={{
                          fontFamily: "Avenir-Roman",
                          fontSize: 16,
                          color: "inherit",
                        }}
                      >
                        Download{" "}
                      </Text>
                      <MdCloudDownload size={25} />{" "}
                    </Space>
                  )}
                </Row>
              </Col>
            </Row>
          </Can>
        </Col>
      </Row>
    );
  };

  const renderLoader = () => {
    if (loading) {
      return (
        <Row style={{ height: "80vh" }} align="middle">
          <Col span={2} offset={11}>
            <Spin size="large" />
          </Col>
        </Row>
      );
    }
  };

  return (
    <Modal
      visible={showModal}
      destroyOnClose={true}
      footer={null}
      onCancel={handleClose}
      width={"90%"}
      centered
      bodyStyle={{ borderRadius: 80 }}
    >
      {renderLoader()}
      {renderBody()}
    </Modal>
  );
}
